import { Injectable } from "@angular/core";
import { ID, QueryEntity } from "@datorama/akita";
import { Observable } from "rxjs";
import { ResourceState, ResourceStore } from "./resource.store";
import { IResource } from "@common/interfaces/resource";
import { IIDNetworkItemsQuery } from "../iidNetworkItems/iidNetworkItems.query";

@Injectable({
  providedIn: 'root'
})
export class ResourceQuery extends QueryEntity<ResourceState> {

  constructor(
    protected store: ResourceStore,
    private iidNetworkItemsQuery: IIDNetworkItemsQuery,
  ) {
    super(store);
  }

  selectResourcesByProjectId(projectId: ID): Observable<IResource[]> {
    return this.selectAll({
      filterBy: entity => entity.projectId === projectId
    })
  }

  selectResourcesByProjectIdAndResourceIds(projectId: ID, resourceIds: string[]): Observable<IResource[]> {
    return this.selectAll({
      filterBy: [
        entity => entity.projectId === projectId,
        entity => resourceIds.includes(entity.id)
      ]
    });
  }

  getResourcesNotInFinalStatesByProjectIdAndCategory<T>(projectId: string, category: string): IResource<T>[] {
    const iidNetworkItemsNotInFinalStates = this.iidNetworkItemsQuery.getIIDNetworkItemsNotInFinalStatesByProjectId(projectId);
    return this.getAll({
      filterBy: [
        resource => resource.projectId === projectId,
        resource => resource.category === category,
        resource => iidNetworkItemsNotInFinalStates.some(iidNetworkItem => iidNetworkItem.resourceIds && iidNetworkItem.resourceIds.includes(resource.id)),
      ]
    });
  }

  getResourcesByProjectIdAndCategory<T>(projectId: ID, category: string): IResource<T>[] {
    return this.getAll({
      filterBy: [
        resource => resource.projectId === projectId,
        resource => resource.category === category
      ]
    });
  }

  getResourcesByProjectIdAndResourceIds<T>(projectId: ID, resourceIds: string[]): IResource<T>[] {
    return this.getAll({
      filterBy: [
        resource => resource.projectId === projectId,
        resource => resourceIds.includes(resource.id)
      ]
    });
  }

  getResourceByProjectIdResourceIdsAndCategory(projectId: ID, resourceIds: string[], category: string): IResource {
    const resources = this.getAll({
      filterBy: [
        resource => resource.projectId === projectId,
        resource => resourceIds.includes(resource.id),
      ]
    });
    return resources.find(resource => category === resource.category);
  }

}
